import { Box } from "@mui/material";
import ChatHeader from "./ChatHeader";
import ChatInput from "./ChatInput";
import { sidebarResizeHandleSx } from "../../../../features/creativeTemplates/editor/useResizableSidebarWidth";

const ChatSidebar = ({
  isSmallScreen,
  title,
  subtitle,
  isProcessing,
  showSendLoading,
  onSendMessage,
  onToggleSidebar,
  scrollRef,
  headerExtra,
  hideHeader = false,
  hideInput = false,
  width = 420,
  resizable = false,
  onResizePointerDown,
  children,
}) => {
  return (
    <Box
      sx={{
        width: { xs: "100%", sm: width },
        maxWidth: { xs: "100%", sm: width },
        height: "100%",
        bgcolor: "background.paper",
        borderRight: { xs: 0, sm: "1px solid rgba(0, 0, 0, 0.12)" },
        display: "flex",
        flexDirection: "column",
        position: "relative",
        minWidth: 0,
        overflow: "hidden",
        flexShrink: 0,
      }}
    >
      {hideHeader ? null : (
        <ChatHeader
          isSmallScreen={isSmallScreen}
          title={title}
          subtitle={subtitle}
          onClose={onToggleSidebar}
        />
      )}

      {headerExtra}

      <Box
        ref={scrollRef}
        sx={{
          flex: 1,
          overflowY: hideInput ? "hidden" : "auto",
          display: "flex",
          flexDirection: "column",
          gap: hideInput ? 0 : 2,
          px: hideInput ? 0 : 2,
          py: hideInput ? 0 : 2,
          minHeight: 0,
        }}
      >
        {children}
      </Box>

      {hideInput ? null : (
        <ChatInput
          onSend={onSendMessage}
          isProcessing={isProcessing}
          showSendLoading={showSendLoading}
        />
      )}
      {resizable && onResizePointerDown ? (
        <Box
          onPointerDown={onResizePointerDown}
          sx={{
            ...sidebarResizeHandleSx,
            display: { xs: "none", sm: "block" },
          }}
        />
      ) : null}
    </Box>
  );
};

export default ChatSidebar;
